const getAgentData = payload => ({
    type: "GET_AGENT_DATA",
    payload
  });
  
  export default {
    getAgentData
  };
  